import React                          from 'react';

import { TypeOfProductsSheetsVector } from 'src/components/vector/type-of-products/type-of-products-sheets';

import { Dialog                     } from 'src/components/common/dialog';
import { RadioGroup,
         RadioGroupItem             } from 'src/components/common/radio-group';
import { Typography                 } from 'src/components/common/typography';

import { Container,
         ProductDialogVariants,
         ProductList, 
         product_dialog_variants    } from 'src/components/features/main/product-type-dialog/ui';

import { storeApi,
         useAppDispatch, 
         useAppSelector             } from 'src/store';



const ITEM_LIST = [
    {
        id: '1',
        label: 'Лист',
        iconKey: 'list'
    },
];

export const PRODUCT_TYPE_ICONS = {
    list: <TypeOfProductsSheetsVector />,
};

export type IconsKeys = keyof typeof PRODUCT_TYPE_ICONS;

type Props = {
  variant: ProductDialogVariants
}
export const ProductTypeDialog: React.FC<Props> = ({ variant }) => {
  const lookAndFeel = product_dialog_variants.get(variant)!;

  const isOpened = useAppSelector(storeApi.main.mainProductTypeDialog.selectors.selectIsOpened)
  const productTypeValue = useAppSelector(storeApi.main.mainProductTypeDialog.selectors.selectProductTypeRadioItem)
  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(storeApi.main.mainProductTypeDialog.action.setIsOpened());
  }

  const handleChange = (value: RadioGroupItem) => {
    dispatch(storeApi.main.mainProductTypeDialog.action.setProductTypeRadioItem(value));
  }

  return (
    <Dialog  variant = { 'lightround' } isOpened = { isOpened } onClose={() => handleClose()}>
      <Container lookAndFeel = { lookAndFeel }>
        <Typography variant = 'steelw400s12lh16'>Вид продукции</Typography>
        <ProductList lookAndFeel = { lookAndFeel }>
          <RadioGroup 
            variant = 'lightwithicon' 
            items = { ITEM_LIST }
            icons = { PRODUCT_TYPE_ICONS }
            value = { productTypeValue }
            onChange = { handleChange } 
          />
        </ProductList>
      </Container>
    </Dialog>
  )
}
